import axios from "axios";
import React, { useEffect, useState } from "react";



export default function AlertMessage({message})

{

    const [id,setId] = useState('')

    function Hfunction(event){
        let idd = event.target.name

        console.log(`id is ${id}`)
        console.log(`mid is ${message['id']}`)

        setId(message['id'])


       

    }


    useEffect(()=>{

        axios.get('https://api.sinatether.com/Auth/seenMessage/',{
            params: {
                 "id":id
              }
        
        
        }
         
         ).then((res)=>{
             
         }).catch((error)=>{
             if (error){
                 console.log(error)
             }
         })


    },[id])
    return(
        <div  className="alert alert-info alert-dismissible fade show " role="alert" >
        <h6 className="text-large mytext-warning text-adkfff">{message['titleMessage']}</h6>
         <span className={'text-normal pr-2'}>
             {message['message']}

         </span>

        <button type="button" name={message['id']} className="close close3434" data-dismiss="alert" aria-label="Close" onClick={Hfunction}>
            <span aria-hidden="true" className="close3434">&times;</span>
        </button>
     </div>

    )
}